import { RowHeightLevel } from '@teable/core';

export const GIRD_ROW_HEIGHT_DEFINITIONS = {
  [RowHeightLevel.AutoFit]: 32,
  [RowHeightLevel.Short]: 32,
  [RowHeightLevel.Medium]: 56,
  [RowHeightLevel.Tall]: 84,
  [RowHeightLevel.ExtraTall]: 108,
};
